"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleWarrantyDTO = void 0;
const enums_1 = require("../enums");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
class VehicleWarrantyDTO {
    constructor(year, km) {
        this.year = year;
        this.km = km;
    }
    toString() {
        return `Until ${this.year} or ${this.km}Kms`;
    }
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        if (!this.year && !this.km) {
            return ['Either year or km must be provided'];
        }
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleWarrantyDTO, plain);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(enums_1.VehicleWarrantyYearType),
    (0, class_validator_1.ValidateIf)((o) => o.km === undefined || o.km === null),
    __metadata("design:type", String)
], VehicleWarrantyDTO.prototype, "year", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.ValidateIf)((o) => o.year === undefined || o.year === null),
    __metadata("design:type", Number)
], VehicleWarrantyDTO.prototype, "km", void 0);
exports.VehicleWarrantyDTO = VehicleWarrantyDTO;
